export enum ControleEstoqueTipoMovimentoFiltroEnum {
  SemFiltro = 0,
  Entrada = 1,
  Saida = 2,
  Inventario = 3,
}
